<div class="mat-toolbar-container">
  <div [ngClass]="{ container: wrapContent }">
    <mat-toolbar class="toolbar ">
      <ng-content></ng-content>
    </mat-toolbar>
  </div>
</div>
